import { Button, Group, Text } from "@mantine/core";
import React, { useState } from "react";
import { useServerApi } from "../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import { openFileUrl } from "../utils/openReport";

const ReportFwdAb03BankAdviceSettlement = () => {
  const [loading, setLoading] = useState(false);
  const [api] = useServerApi();
  const { t } = useTranslation();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const canDownload = Boolean(fromDate || toDate);

  const downloadReport = async () => {
    try {
      setLoading(true);
      const result = await api.FwdReport.getAb03BankAdviceSettlement({
        fromDate,
        toDate,
      });
      if (result?.url) {
        await openFileUrl(result.url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Text size="xs">{t("Please select the bank-in period.")}</Text>
      <Group mt="xs">
        <DatePicker
          title={t("From Date")}
          size="xs"
          allowFreeInput
          placeholder="From"
          value={fromDate}
          onChange={setFromDate}
        />
        -
        <DatePicker
          title={t("To Date")}
          size="xs"
          allowFreeInput
          placeholder="To"
          value={toDate}
          onChange={setToDate}
        />
      </Group>
      <Button
        size="xs"
        mt="xl"
        onClick={downloadReport}
        loading={loading}
        disabled={!canDownload}
      >
        {t("Download")}
      </Button>
    </div>
  );
};

export default ReportFwdAb03BankAdviceSettlement;
